import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment as env } from '../../../environments/environment';
import { type User, UserType } from '../../shared/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private readonly token = signal<string | null>(null);
  private readonly user = signal<User | null>(null);
  private readonly endpoint = env.baseAPIUrl + '/auth';

  constructor(private readonly http: HttpClient, private readonly router: Router) { }

  authenticate(email: string, password: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${this.endpoint}/login`, { email, password });
  }

  get userInfo(): Signal<User | null> {
    return this.user.asReadonly();
  }

  set userInfo(user: User) {
    this.user.set(user);
  }

  getToken(): string | null {
    if (!this.token()) {
      const token = localStorage.getItem('token');
      if (token) {
        this.token.set(token);
      }
    }
    return this.token();
  }

  setToken(jwt: { token: string }) {
    this.token.set(jwt.token);
    localStorage.setItem('token', jwt.token);
  }

  hasRole(roles: UserType[]): boolean {
    return roles.some((role) => this.userInfo()?.type === role);
  }

  logout(shouldRedirect: boolean = true) {
    this.user.set(null);
    this.token.set(null);
    localStorage.removeItem('token');
    if (shouldRedirect) {
      this.router.navigate(['/login']);
    }
  }
}
